/* Product Gallery Behavior Overrides
   - Thumbnail free-flow scroll (no Slick snap)
   - Thumbnail swipe does not change main image
   - Arrows scroll the strip without changing active thumbnail
   - Main image uses slide transition
*/
(function($) {
  function initThumbScroll() {
    var $thumbs = $('.pr_thumbs');
    var $mainSlider = $('.primgSlider');
    var $thumbsNav = $thumbs.closest('.thumbs_nav');

    if (!$thumbs.length || !$mainSlider.length) return;

    // If Slick was auto-initialized on thumbnails, destroy it
    if ($thumbs.hasClass('slick-initialized')) {
      $thumbs.slick('unslick');
    }

    // Ensure all thumbnails are visible after unslick and reveal
    $thumbs.find('.pr_thumbs_item').css({
      display: '',
      width: '',
      opacity: '1'
    });
    $thumbs.addClass('c-thumb-ready');

    // Inject scroll arrows into the thumbs_nav wrapper
    if ($thumbsNav.length && !$thumbsNav.find('.c-thumb-arrow').length) {
      $thumbsNav.css('position', 'relative');
      $thumbsNav.append(
        '<button type="button" class="c-thumb-arrow c-thumb-prev" aria-label="Scroll thumbnails back"></button>' +
        '<button type="button" class="c-thumb-arrow c-thumb-next" aria-label="Scroll thumbnails forward"></button>'
      );

      var $prev = $thumbsNav.find('.c-thumb-prev');
      var $next = $thumbsNav.find('.c-thumb-next');

      // Scroll by ~2 thumbnail widths on arrow click
      $prev.on('click', function() {
        scrollThumbs($thumbs, -1);
      });
      $next.on('click', function() {
        scrollThumbs($thumbs, 1);
      });

      // Show/hide arrows based on overflow
      updateArrowVisibility($thumbs, $prev, $next);
      $thumbs[0].addEventListener('scroll', function() {
        updateArrowVisibility($thumbs, $prev, $next);
      }, { passive: true });
      $(window).on('resize', function() {
        updateArrowVisibility($thumbs, $prev, $next);
      });
    }

    // Set initial active thumbnail
    var initialSlide = $mainSlider.slick('slickCurrentSlide') || 0;
    updateActiveThumb($thumbs, initialSlide);

    // Sync: when main slider changes, scroll active thumbnail into view
    $mainSlider.on('afterChange', function(event, slick, currentSlide) {
      updateActiveThumb($thumbs, currentSlide);
    });
  }

  function scrollThumbs($thumbs, direction) {
    var container = $thumbs[0];
    var isVertical = $thumbs.hasClass('c-thumb-vertical') && window.innerWidth >= 768;
    var $firstThumb = $thumbs.find('.pr_thumbs_item').first();
    // Scroll by 2 thumbnail sizes
    var scrollAmount = isVertical
      ? $firstThumb.outerHeight(true) * 2
      : $firstThumb.outerWidth(true) * 2;

    if (isVertical) {
      container.scrollBy({ top: scrollAmount * direction, behavior: 'smooth' });
    } else {
      container.scrollBy({ left: scrollAmount * direction, behavior: 'smooth' });
    }
  }

  function updateArrowVisibility($thumbs, $prev, $next) {
    var el = $thumbs[0];
    var isVertical = $thumbs.hasClass('c-thumb-vertical') && window.innerWidth >= 768;

    if (isVertical) {
      var hasOverflow = el.scrollHeight > el.clientHeight + 1;
      $prev.add($next).toggleClass('c-thumb-arrow-hidden', !hasOverflow);
      if (hasOverflow) {
        $prev.toggleClass('c-thumb-arrow-disabled', el.scrollTop <= 1);
        $next.toggleClass('c-thumb-arrow-disabled', el.scrollTop + el.clientHeight >= el.scrollHeight - 1);
      }
    } else {
      var hasOverflow = el.scrollWidth > el.clientWidth + 1;
      $prev.add($next).toggleClass('c-thumb-arrow-hidden', !hasOverflow);
      if (hasOverflow) {
        $prev.toggleClass('c-thumb-arrow-disabled', el.scrollLeft <= 1);
        $next.toggleClass('c-thumb-arrow-disabled', el.scrollLeft + el.clientWidth >= el.scrollWidth - 1);
      }
    }
  }

  function updateActiveThumb($thumbs, slideIndex) {
    var $activeThumb = $thumbs.find('.pr_thumbs_item[data-slide="' + slideIndex + '"]');
    if (!$activeThumb.length) return;

    // Update active state — also remove Liquid's activeSlide so only one thumb is highlighted
    $thumbs.find('.pr_thumb').removeClass('active-thumb activeSlide');
    $activeThumb.find('.pr_thumb').addClass('active-thumb');

    // Scroll the active thumbnail into view
    var thumbEl = $activeThumb[0];
    var container = $thumbs[0];

    if ($thumbs.hasClass('c-thumb-vertical') && window.innerWidth >= 768) {
      var thumbTop = thumbEl.offsetTop;
      var thumbHeight = thumbEl.offsetHeight;
      var scrollTop = container.scrollTop;
      var containerHeight = container.clientHeight;

      if (thumbTop < scrollTop || thumbTop + thumbHeight > scrollTop + containerHeight) {
        container.scrollTo({
          top: thumbTop - (containerHeight / 2) + (thumbHeight / 2),
          behavior: 'smooth'
        });
      }
    } else {
      var thumbLeft = thumbEl.offsetLeft;
      var thumbWidth = thumbEl.offsetWidth;
      var scrollLeft = container.scrollLeft;
      var containerWidth = container.clientWidth;

      if (thumbLeft < scrollLeft || thumbLeft + thumbWidth > scrollLeft + containerWidth) {
        container.scrollTo({
          left: thumbLeft - (containerWidth / 2) + (thumbWidth / 2),
          behavior: 'smooth'
        });
      }
    }
  }

  // Prevent vertical page scroll when swiping the main image horizontally.
  // Without this, the browser's native scroll hijacks the touch and
  // the carousel doesn't respond. Must be { passive: false } so
  // preventDefault() actually works on touchmove.
  function initMainSliderTouch() {
    var slickList = document.querySelector('.primgSlider .slick-list');
    if (!slickList) return;

    var startX, startY, direction; // 'h' = horizontal, 'v' = vertical, null = undecided

    slickList.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      direction = null;
    }, { passive: true });

    slickList.addEventListener('touchmove', function(e) {
      if (!startX || !startY) return;

      var diffX = Math.abs(e.touches[0].clientX - startX);
      var diffY = Math.abs(e.touches[0].clientY - startY);

      // Wait until finger moves at least 8px before deciding direction
      if (!direction && (diffX > 8 || diffY > 8)) {
        direction = diffX >= diffY ? 'h' : 'v';
      }

      // Horizontal swipe — block the page scroll so Slick can handle it
      if (direction === 'h') {
        e.preventDefault();
      }
    }, { passive: false }); // passive: false is critical here
  }

  // Run after Slick has initialized on the page
  if (document.readyState === 'complete') {
    initThumbScroll();
    initMainSliderTouch();
  } else {
    $(window).on('load', function() {
      setTimeout(function() {
        initThumbScroll();
        initMainSliderTouch();
      }, 100);
    });
  }
})(jQuery);
